<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M24.4 7.93A10 10 0 009.6 21.34L5.92 25a1 1 0 001.41 1.42L11 22.78A10 10 0 0024.4 7.93zM23 20.66A8 8 0 1125.33 15 7.95 7.95 0 0123 20.66z"/></svg>